import { usePostHog } from 'posthog-js/react';
import { useMemo } from 'react';
import { browserEvent } from './touchpointEvents';

// Event names - consistent naming convention
export const POSTHOG_EVENTS = {
  GENERATION_BEGIN: 'generation_begin',
  GENERATION_COMPLETE: 'generation_complete',
  EMAIL_PROMPT_SHOWN: 'email_prompt_shown',
  EMAIL_ENTERED: 'email_entered',
  VISIT_SUPERWALL_CLICKED: 'visit_superwall_clicked',
  SHARE_LINK_CLICKED: 'share_link_clicked',
  TRY_ANOTHER_CLICKED: 'try_another_clicked',
  EXAMPLE_CLICKED: 'example_clicked',
} as const;

// Hook to use PostHog
export function usePostHogTracking() {
  const posthog = usePostHog();
  return useMemo(() => ({
    capture: (...args: Parameters<typeof posthog.capture>) => {
      const [event, properties] = args;
      const safe = browserEvent({ event, properties });
      if (safe) {
        void fetch('/api/analytics/events', {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, keepalive: true,
          body: JSON.stringify({ event, properties: safe.properties }),
        }).catch(() => {});
      }
      return posthog.capture(...args);
    },
    identify: posthog.identify.bind(posthog),
  }), [posthog]);
}

// Helper function to identify user with email
export function identifyUserWithEmail(posthog: ReturnType<typeof usePostHogTracking> | null, email: string) {
  if (!posthog || !email) return;
  
  posthog.identify(email, {
    email: email,
  });
}

